import {Factory as DraftKingsFactory} from './sites/draftkings/factory';
import {Factory as FanDuelFactory} from './sites/fanduel/factory';
import {Factory as YahooFactory} from './sites/yahoo/factory';
import Const from 'constants';

const classesMap = {
    [Const.SITE_DK]: DraftKingsFactory,
    [Const.SITE_FD]: FanDuelFactory,
    [Const.SITE_YAHOO]: YahooFactory,
};

const Factory = {
    getComponent(sportConfig) {
        const siteName = sportConfig.getSite().toLowerCase();

        if (siteName in classesMap) {
            return classesMap[siteName].getComponent(sportConfig);
        }

        throw new Error(`Unsupported factory for "${siteName}".`);
    },
};

export {Factory};
